import { gql } from '@apollo/client';

export const CREATE_GROUP = gql`
  mutation($input: CreateGroupMutationInput!) {
    createGroup(input: $input) {
      group {
        name
        id
      }
      clientMutationId
    }
  }
`;
